const { default: images } = require('assets/images')

const arrDex = [
  {
    name: 'Binance',
    logo: images.vicLogo1,
    link: 'https://www.binance.com'
  },
  {
    name: 'ByBit',
    logo: images.vicLogo2,
    link: 'https://www.bybit.com'
  },
  {
    name: 'Aliniex',
    logo: images.vicLogo3,
    link: 'https://aliniex.com'
  },
  {
    name: 'Gate.io',
    logo: images.vicLogo4,
    link: 'https://www.gate.com'
  },
  {
    name: 'Bitget',
    logo: images.vicLogo5,
    link: 'https://www.bitget.com'
  },
  {
    name: 'AscendEx',
    logo: images.vicLogo6,
    link: 'https://ascendex.com/'
  },
  {
    name: 'BTSE',
    logo: images.vicLogo7,
    link: 'https://www.btse.com'
  },
  {
    name: 'BingX',
    logo: images.vicLogo8,
    link: 'https://bingx.com'
  },
  {
    name: 'MEXC',
    logo: images.vicLogo9,
    link: 'https://www.mexc.com'
  },
  {
    name: 'Tokocrypto',
    logo: images.vicLogo10,
    link: 'https://www.tokocrypto.com'
  },
  {
    name: 'Bitkub',
    logo: images.vicLogo11,
    link: 'https://www.bitkub.com'
  },
  {
    name: 'Coins.ph',
    logo: images.vicLogo12,
    link: 'https://coins.ph'
  },
  {
    name: 'Indodax',
    logo: images.vicLogo13,
    link: 'https://indodax.com'
  },
  {
    name: 'SimpleSwap',
    logo: images.vicLogo14,
    link: 'https://simpleswap.io'
  },
  {
    name: 'HTX',
    logo: images.vicLogo15,
    link: 'https://www.htx.com'
  },
  {
    name: 'Biconomy',
    logo: images.vicLogo16,
    link: 'https://www.biconomy.io'
  },
  {
    name: 'SteathEX',
    logo: images.vicLogo17,
    link: 'https://stealthex.io'
  },
  {
    name: 'Bitmart',
    logo: images.vicLogo18,
    link: 'https://www.bitmart.com'
  },
  {
    name: 'Lbank',
    logo: images.vicLogo19,
    link: 'https://www.lbank.com'
  },
  {
    name: 'Giottus',
    logo: images.vicLogo20,
    link: 'https://www.giottus.com'
  },
  {
    name: 'Pintu',
    logo: images.vicLogo21,
    link: 'https://pintu.co.id'
  },
]

const arrDex2 = [
  {
    name: 'AlixPay',
    logo: images.vicLogo39,
    link: 'https://ramp.aliniex.com'
  },
  {
    name: 'Banxa',
    logo: images.vicLogo40,
    link: 'https://checkout.banxa.com'
  },
  {
    name: 'AlchemyPay',
    logo: images.vicLogo41,
    link: 'https://ramp.alchemypay.org'
  },
]

const arrToken = [
  {
    name: 'C98',
    logo: images.vicLogo24,
    value: 'c98'
  },
  {
    name: 'USDT',
    logo: images.vicLogo25,
    value: 'usdt'
  },
  {
    name: 'SAROS',
    logo: images.vicLogo26,
    value: 'saros'
  },
  {
    name: 'ONEID',
    logo: images.vicLogo27,
    value: 'oneId'
  },
  {
    name: 'DADA',
    logo: images.vicLogo28,
    value: 'dada'
  },
  {
    name: 'ETER',
    logo: images.vicLogo29,
    value: 'eter'
  },
  {
    name: 'RABBIT',
    logo: images.vicLogo30,
    value: 'rabbit'
  },
]

const arrChain = [
  {
    name: 'Ethereum',
    logo: images.vicLogo31,
    value: 'eth',
    dex: [
      {
        name: 'Arken Bridge',
        logo: images.vicLogo35,
        link: 'https://arken.ag/swap/viction/0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee/0xb3008e7156ae2312b49b5200c3e1c3e80e529feb'
      },
      {
        name: 'Hyperlane',
        logo: images.vicLogo36,
        link: 'https://hyperlane.xyz'
      },
      {
        name: 'SpaceGate',
        logo: images.vicLogo37,
        link: 'https://docs.coin98.com/products/coin98-super-wallet/mobile/swapx/convert-tokens'
      }
    ]
  },
  {
    name: 'Abitrum One',
    logo: images.vicLogo32,
    value: 'abr',
    dex: [
      {
        name: 'Arken Bridge',
        logo: images.vicLogo35,
        link: 'https://arken.ag/swap/viction/0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee/0xb3008e7156ae2312b49b5200c3e1c3e80e529feb'
      },
      {
        name: 'SpaceGate',
        logo: images.vicLogo37,
        link: 'https://docs.coin98.com/products/coin98-super-wallet/mobile/swapx/convert-tokens'
      }
    ]
  },
  {
    name: 'BNB Chain',
    logo: images.vicLogo33,
    value: 'bnb',
    dex: [
      {
        name: 'Arken Bridge',
        logo: images.vicLogo35,
        link: 'https://arken.ag/swap/viction/0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee/0xb3008e7156ae2312b49b5200c3e1c3e80e529feb'
      },
      {
        name: 'SpaceGate',
        logo: images.vicLogo37,
        link: 'https://docs.coin98.com/products/coin98-super-wallet/mobile/swapx/convert-tokens'
      }
    ]
  },
  {
    name: 'Solana',
    logo: images.vicLogo34,
    value: 'sol',
    dex: [
      {
        name: 'Saros',
        logo: images.vicLogo38,
        link: 'https://dlmm.saros.xyz/pool'
      }
    ]
  },
]

export {
  arrDex,
  arrDex2,
  arrToken,
  arrChain
}